import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../util/Auth";
import AccessDenied from "../../pages/accessDenied/AccessDenied";
import { UserRole } from "../../models/User";

type ProtectedRouteProps = {
  element: React.ReactNode;
  isProtected?: boolean;
  allowedRoles?: UserRole[];
  skipContactInfoGate?: boolean;
};

export default function ProtectedRoute({
  element,
  isProtected = true,
  allowedRoles,
  skipContactInfoGate = false
}: ProtectedRouteProps) {
  const authContext = useAuth();
  const { user, isAuthLoading } = authContext;
  const location = useLocation();

  // Se a rota não é protegida, renderiza normalmente
  if (!isProtected) {
    return <>{element}</>;
  }

  if (isAuthLoading) {
    return null;
  }

  // Se a rota é protegida mas não há usuário logado
  if (!user) {
    return <AccessDenied />;
  }

  // Se há roles específicas e o usuário não tem nenhuma delas
  if (allowedRoles && allowedRoles.length > 0) {
    const hasRequiredRole = user.roles.some((role) =>
      allowedRoles.includes(role.toLowerCase() as UserRole)
    );

    if (!hasRequiredRole) {
      return <AccessDenied />;
    }
  }

  if (
    !authContext.contactInfoStale &&
    !skipContactInfoGate &&
    location.pathname !== "/update-contact-info"
  ) {
    return <Navigate to="/update-contact-info" replace />;
  }

  if (authContext.contactInfoStale && location.pathname === "/update-contact-info") {
    return <Navigate to="/user-home" replace />;
  }

  // Usuário está autenticado e autorizado
  return <>{element}</>;
}
